<template>
	<el-form :model="form" :rules="rules" ref="form" label-width="130px" class="export-form-first">
		<el-form-item label="子品牌" prop="childBrandIdentify">
			<el-select v-model="form.childBrandIdentify" placeholder="请选择子品牌" style="width: 100%;">
				<el-option v-for="(item,index) in subBrandList" :label="item.name" :value="item.id" :key="index"></el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="数据文件名称" prop="name">
			<el-input v-model="form.name" placeholder="请输入数据文件名称"></el-input>
		</el-form-item>
		<el-form-item label="备注" prop="batchRemarks">
		    <el-input type="textarea" v-model="form.batchRemarks" placeholder="请输入备注信息"></el-input>
		</el-form-item>
		<el-form-item label="是否去重" prop="autoDistinct">
		    <el-switch v-model="form.autoDistinct"  active-text="是"  inactive-text="否"  active-value="1" inactive-value="0"></el-switch>
		</el-form-item>
		<el-form-item label="去重字段">
		    <span>电话号码</span>
		</el-form-item>
		<el-form-item label="去重范围" prop="autoDistinctRange" v-if="form.autoDistinct == 1">
			<el-select v-model="form.autoDistinctRange" placeholder="请选择去重范围" clearable>
				<el-option label="当前文件" value="0"></el-option>
				<el-option label="导入时间" value="1"></el-option>
				<el-option label="当前文件+导入时间" value="2"></el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="导入时间" prop="date" v-if="form.autoDistinct == 1 && (form.autoDistinctRange != '0' && form.autoDistinctRange)">
		    <el-date-picker
		          v-model="form.date"
				  value-format="yyyy-MM-dd HH:mm:ss"
		          type="datetimerange"
		          range-separator="至"
		          start-placeholder="开始日期"
		          end-placeholder="结束日期"/>
		</el-form-item>
		<template v-if="form.autoDistinctRange">
			<p class="tips" v-show="form.autoDistinctRange == 0">当前文件去重：在当前文件中，若导入数据中的电话号码已存在，这些重复的【导入数据】将被过滤。</p>
			<p class="tips" v-show="form.autoDistinctRange == 1">按导入时间去重：在所选品牌下的所有数据的导入时间范围中，若【导入数据】中的电话号已存在这些重复的导入数据将被过滤。</p>
			<p class="tips" v-show="form.autoDistinctRange == 2">当前文件+按导入时间去重：在当前文件的导入时间范围中，若导入数据中的电话号已存在，这些重复的【导入数据】将被过滤。</p>
			
		</template>
		
		<el-form-item label="Excel/CSV文件上传" prop="file">
			<el-upload
				style="width: 200px;"
				action=""
				accept=".xls,.csv,.xlsx"
				:http-request="uploadEvent"
				:limit="1"
				:file-list="form.file">
				<el-button size="small" type="primary">点击上传</el-button>
				<div slot="tip" class="el-upload__tip">
					<p>只能上传excel/csv文件</p>
					<p>字段必须包含【移动电话】列</p>
					<!-- <p>下载	<a :href="excel_model" target="_download">【Excel模板】</a> 或 <a :href="csv_model" target="_download">【CSV模板】</a></p> -->
				</div>
			</el-upload>
		</el-form-item>
		<el-form-item style="float: right;">
		     <el-button @click="onCancel">取消</el-button>
			 <el-button type="primary" @click="onSubmit" :loading="loading">{{loading ? '提交中' : '立即提交'}}</el-button>
			 
		  </el-form-item>
	</el-form>
</template>

<script>
	import { mapGetters } from "vuex";
	export default {
		computed: {
		    ...mapGetters([ 
				'subBrandList',
				'userInfo'
			])
		},
		data() {
			return {
				form: {
					childBrandIdentify:'',
					date:[],
					file:[],
					name:'',
					batchRemarks:'',
					autoDistinct:'0',
					autoDistinctRange:'',
					id:''
					
					
				},
				rules:{
					childBrandIdentify:[{required:true,message:'请选择子品牌',trigger:'change'}],
					date:[{required:true,message:'请选择日期',trigger:'change'}],
					name:[{required:true,message:'请输入数据名称',trigger:'blur'}],
					file:[{required:true,message:'请上传文件',trigger:'change'}],
					autoDistinctRange:[{required:true,message:'请选择去重范围',trigger:'change'}],
				},
				excel_model:'',
				csv_model:'',
				real_file:'',
				loading:false,
				
			}
		},
		methods: {
			onEdit(row){
				this.onReset();
				this.$nextTick(()=>{
					this.form.id = row.id;
					this.form.name = row.name;
					this.form.childBrandIdentify = row.childBrandIdentify ? row.childBrandIdentify : this.form.childBrandIdentify;
					
				})
			},
			onCancel(){
				this.$emit('onCancel')
			},
			onReset(){
				this.$nextTick(() => {
					this.$refs.form.resetFields();
					this.form.childBrandIdentify = this.userInfo.brandList && this.userInfo.brandList.length > 0 ? this.userInfo.brandList[0] : '';
				})
			},
			onSubmit(){
				this.$refs.form.validate((valid) => {
					if(valid){
						this.loading = true;
						const formData = new FormData()
						formData.append('file', this.form.file[0]);
						formData.append('brandIdentify', this.$store.getters.userInfo.brandIdentify);
						formData.append('childBrandIdentify', this.form.childBrandIdentify);
						formData.append('name', this.form.name);
						formData.append('batchRemarks', this.form.batchRemarks);
						formData.append('autoDistinct', this.form.autoDistinct);
						formData.append('autoDistinctRange', this.form.autoDistinctRange);
						formData.append('endImportTime', this.form.date[1]);
						formData.append('startImportTime', this.form.date[0]);
						if(this.form.id){
							formData.append('batchNum', this.form.id);
						}
						this.$api.stepFirstBreathdataBaseList(formData).then(res => {
								this.loading = false;
								if(res.errcode != 0) return;
								this.$notify.success(this.form.id ? '导入成功' : '新增成功');
								this.$emit('updateStepFirst',res.data);
						}).catch(err => {
							this.loading = false;
						})
					}
				})
			},
			async uploadEvent(params){
				if(this.beforeUpload(params.file)) {
					this.form.file = [params.file];
				}
			},
			beforeUpload(file){
				const isTrue = file.name.indexOf('xlsx') != -1 || file.name.indexOf('csv') != -1;
				if(!isTrue) {
					this.$message.error(`上传只能是xlxs或者csv格式`);
					this.form.file = [];
					return false
				}
				return true
			}
		},
	}
</script>

<style lang="scss" scoped>
	.export-form-first {
		width: 100%;
		box-sizing: border-box;
		margin-top: 20px;
		.tips {
			font-size: 12px;
			padding: 0 20px;
			color: #838A9D;
			margin: 10px 0;
		}
		a {
			color: #337EFF;
		}
	}
</style>
